// extracted by mini-css-extract-plugin
module.exports = {"MobileBreakpoint":"800px","planCards":"Plans_planCards__28_fg","header":"Plans_header__5hIwg","plans":"Plans_plans__kQc_y","mobile":"Plans_mobile__1klMw"};